import { taipeiDay } from '@/utils/taipeiTime';

/** 與 gonghao_frontend/constants/bookingSlots 對齊（中午 12:00–13:00 為休息，不在此列表） */
export const CONSULTATION_SLOT_DEFS = [
    { start: '10:00', label: '10:00 – 11:00', end: '11:00' },
    { start: '11:00', label: '11:00 – 12:00', end: '12:00' },
    { start: '13:00', label: '13:00 – 14:00', end: '14:00' },
    { start: '14:00', label: '14:00 – 15:00', end: '15:00' },
    { start: '15:00', label: '15:00 – 16:00', end: '16:00' },
    { start: '16:00', label: '16:00 – 17:00', end: '17:00' },
    { start: '17:00', label: '17:00 – 18:00', end: '18:00' },
    { start: '18:30', label: '18:30 – 19:30', end: '19:30' },
    { start: '19:30', label: '19:30 – 20:30', end: '20:30' }
];

export const SLOT_STARTS = CONSULTATION_SLOT_DEFS.map((s) => s.start);

/**
 * 依 starts_at 顯示時段標籤；若不在標準 9 格內，以「開始 – 開始+1h」顯示（避免只出現「12:00」造成誤解）
 */
export function formatSlotTimeLabel(startsAt) {
    const start = taipeiDay(startsAt);
    if (!start.isValid()) return String(startsAt ?? '');
    const hm = start.format('HH:mm');
    const def = CONSULTATION_SLOT_DEFS.find((s) => s.start === hm);
    if (def) return def.label;
    return `${hm} – ${start.add(1, 'hour').format('HH:mm')}`;
}
